export default {
  BLACK: "#01001d",
  GREY_1: "#0d0d0d",
  GREY_2: "#1d1d1f",
  GREY_3: "#333334",
  B_GREY_1: "#443752",
  B_GREY_2: "#5f5473",
  B_GREY_3: "#827d9a", 
  B_GREY_4: "#a5a4ba",
  B_GREY_5: "#dcdce6",

  RED_1: "#702931",
  RED_2: "#994639",
  RED_4: "#e0c270",

  BROWN_4: "#9e7762",

  BLUE_1: "#45538f",

  BROWN_1: "#523839",
  BROWN_2: "#78524d",
  BROWN_3: "#9e7762"
};